import React, { useState } from 'react';

const teamMembers = [
  {
    name: "John Doe",
    position: "Chief Executive Officer",
    experience: "20+ years in construction and engineering",
    image: "https://img.freepik.com/free-photo/portrait-expressive-young-man-wearing-formal-suit_273609-6942.jpg?ga=GA1.1.341967142.1748248136&semt=ais_items_boosted&w=740",
    specialties: ["Strategic Leadership", "Business Development", "Construction Management", "Risk Assessment"],
    education: "MSc Civil Engineering, University of Nairobi",
    bio: "John leads JTG Enterprises with a vision for sustainable infrastructure development. His two decades of experience span major construction projects across East Africa, with a focus on innovative engineering solutions.",
    linkedin: "#",
    email: "john.doe@jtgenterprises.com"
  },
  {
    name: "Jane Smith",
    position: "Operations Director",
    experience: "15+ years in project management",
    image: "https://img.freepik.com/free-photo/medium-shot-female-economist-working-office_23-2150251746.jpg?ga=GA1.1.341967142.1748248136&semt=ais_items_boosted&w=740",
    specialties: ["Operations Management", "Quality Assurance", "Team Leadership", "Process Optimization"],
    education: "MBA Operations Management, Strathmore University",
    bio: "Jane ensures seamless project execution through efficient operations management. Her expertise in quality assurance and process optimization has been instrumental in our project success rate.",
    linkedin: "#",
    email: "jane.smith@jtgenterprises.com"
  },
  {
    name: "Michael Johnson",
    position: "Project Director",
    experience: "18+ years in infrastructure development",
    image: "https://img.freepik.com/free-photo/happy-successful-businessman-posing-outside_74855-2004.jpg?ga=GA1.1.341967142.1748248136&semt=ais_items_boosted&w=740",
    specialties: ["Infrastructure Development", "Project Planning", "Budget Management", "Stakeholder Relations"],
    education: "BEng Structural Engineering, Jomo Kenyatta University",
    bio: "Michael oversees our largest infrastructure projects, bringing extensive experience in complex project coordination and stakeholder management. His leadership ensures projects are delivered on time and within budget.",
    linkedin: "#",
    email: "michael.johnson@jtgenterprises.com"
  },
  {
    name: "Sarah Williams",
    position: "Technical Director",
    experience: "16+ years in engineering",
    image: "https://img.freepik.com/free-photo/confident-business-woman-portrait-smiling-face_53876-137693.jpg?ga=GA1.1.341967142.1748248136&semt=ais_items_boosted&w=740",
    specialties: ["Technical Innovation", "Engineering Design", "Safety Standards", "Sustainability"],
    education: "PhD Structural Engineering, Technical University of Kenya",
    bio: "Sarah drives technical excellence and innovation across all our projects. Her expertise in sustainable engineering practices and safety standards has established new industry benchmarks.",
    linkedin: "#",
    email: "sarah.williams@jtgenterprises.com"
  },
  {
    name: "David Chen",
    position: "Financial Director",
    experience: "14+ years in financial management",
    image: "https://img.freepik.com/free-photo/business-man-banner-concept-with-copy-space_23-2149601521.jpg?ga=GA1.1.341967142.1748248136&semt=ais_items_boosted&w=740",
    specialties: ["Financial Planning", "Investment Analysis", "Cost Control", "Risk Management"],
    education: "CPA, MBA Finance, University of Nairobi",
    bio: "David manages our financial strategy and ensures optimal resource allocation across projects. His analytical approach to cost management has consistently delivered value to our clients.",
    linkedin: "#",
    email: "david.chen@jtgenterprises.com"
  },
  {
    name: "Grace Ochieng",
    position: "Environmental Director",
    experience: "12+ years in environmental compliance",
    image: "https://img.freepik.com/free-photo/fashionable-smiling-young-woman-with-hair-buns-dressed-green-jacket-wears-vivid-makeup-looks-away-happily-enjoys-leisure-time-city-poses-outdoors-against-blurred-background-feels-glad_273609-57040.jpg?ga=GA1.1.341967142.1748248136&semt=ais_items_boosted&w=740",
    specialties: ["Environmental Impact", "Sustainability", "Compliance", "Green Building"],
    education: "MSc Environmental Engineering, University of Nairobi",
    bio: "Grace leads our commitment to environmental responsibility and sustainable construction practices. Her expertise ensures all projects meet the highest environmental standards.",
    linkedin: "#",
    email: "grace.ochieng@jtgenterprises.com"
  }
];

const Team = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <section id="team" className="relative min-h-screen bg-slate-950 overflow-hidden">
      {/* Enhanced Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Gradient overlays */}
        <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-gradient-to-br from-purple-500/20 to-pink-600/20 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-gradient-to-br from-cyan-500/15 to-blue-500/15 rounded-full blur-3xl animate-float-delayed" />
        
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(59,130,246,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(59,130,246,0.05)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 lg:py-32">
        
        {/* Section Header */}
        <div className="text-center mb-20 animate-fade-in">
          <div className="inline-flex items-center gap-2 bg-purple-500/10 backdrop-blur-sm border border-purple-500/20 rounded-full px-4 py-2 text-sm font-medium text-purple-400 mb-6">
            <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse" />
            Leadership Team
          </div>
          
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Meet Our
            <span className="block bg-gradient-to-r from-purple-400 via-pink-500 to-cyan-600 bg-clip-text text-transparent">
              Expert Leaders
            </span>
          </h2>
          
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            Our accomplished leadership team brings together decades of combined experience 
            in construction, engineering, and project management to deliver exceptional results.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-16">
          {teamMembers.map((member, index) => (
            <div
              key={member.name}
              className="group relative animate-slide-up cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => setSelectedMember(member)}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-pink-600/20 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-all duration-500" />
              <div className="relative bg-slate-900/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl overflow-hidden hover:border-purple-500/30 transition-all duration-500">
                
                {/* Member Image */}
                <div className="relative h-64 sm:h-72 lg:h-80 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent" />
                  
                  {/* Experience Badge */}
                  <div className="absolute top-4 right-4">
                    <div className="px-3 py-1 bg-gradient-to-r from-purple-400 to-pink-500 text-white text-xs font-semibold rounded-full shadow-lg">
                      {member.experience.split(' ')[0]} Experience
                    </div>
                  </div>

                  {/* Hover Overlay with Social Links */}
                  <div className="absolute inset-0 bg-purple-600/90 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center">
                    <div className="text-center text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      <div className="mb-4">
                        <svg className="w-12 h-12 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <span className="text-sm font-medium">View Profile</span>
                      </div>
                      <div className="flex justify-center gap-3">
                        <a href={member.linkedin} className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors duration-300">
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                          </svg>
                        </a>
                        <a href={`mailto:${member.email}`} className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors duration-300">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Member Info Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-bold text-white mb-1 group-hover:text-purple-400 transition-colors duration-300">
                      {member.name}
                    </h3>
                    <p className="text-purple-300 font-medium mb-2">{member.position}</p>
                    <p className="text-slate-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {member.specialties.slice(0, 2).join(" • ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Stats */}
        <div className="bg-slate-900/30 backdrop-blur-sm border border-slate-700/50 rounded-3xl p-6 sm:p-8 lg:p-12 mb-16 animate-fade-in-delayed">
          <div className="text-center mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">Leadership Excellence</h3>
            <p className="text-slate-300 max-w-2xl mx-auto text-sm sm:text-base">
              Our leadership team's combined expertise drives innovation and excellence across all projects
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {[
              { number: "100+", label: "Combined Years Experience", gradient: "from-purple-400 to-pink-500" },
              { number: "50+", label: "Major Projects Led", gradient: "from-cyan-400 to-blue-500" },
              { number: "15+", label: "Industry Awards", gradient: "from-green-400 to-emerald-500" },
              { number: "6", label: "Expert Directors", gradient: "from-yellow-400 to-orange-500" }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`text-3xl lg:text-4xl font-bold bg-gradient-to-r ${stat.gradient} bg-clip-text text-transparent mb-2`}>
                  {stat.number}
                </div>
                <div className="text-sm text-slate-400 uppercase tracking-wider leading-tight">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center animate-fade-in-delayed">
          <div className="bg-slate-900/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">Join Our Team</h3>
            <p className="text-slate-300 mb-6">
              We're always looking for talented professionals to join our growing team and contribute to Kenya's development.
            </p>
            <a href="#team">
            <button className="group relative px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-600 text-white font-semibold rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/25 hover:-translate-y-1">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <span className="relative flex items-center gap-2">
                View Career Opportunities
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </button>
            </a>
          </div>
        </div>
      </div>

      {/* Team Member Modal */}
      {selectedMember && (
        <div className="fixed inset-0 bg-slate-950/90 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="relative w-full max-w-4xl my-8">
            <div className="bg-slate-900/80 backdrop-blur-xl border border-slate-700/50 rounded-3xl overflow-hidden">
              
              {/* Modal Header */}
              <div className="relative">
                <div className="flex flex-col md:flex-row">
                  <div className="md:w-1/3">
                    <img
                      src={selectedMember.image}
                      alt={selectedMember.name}
                      className="w-full h-48 sm:h-64 md:h-full object-cover"
                    />
                  </div>
                  <div className="md:w-2/3 p-4 sm:p-6 md:p-8 flex flex-col justify-center">
                    <div className="mb-4">
                      <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">{selectedMember.name}</h3>
                      <p className="text-lg sm:text-xl text-purple-400 font-medium mb-2">{selectedMember.position}</p>
                      <p className="text-slate-300 text-sm sm:text-base">{selectedMember.experience}</p>
                    </div>
                    
                    <div className="mb-6">
                      <h4 className="text-base sm:text-lg font-semibold text-white mb-2">Education</h4>
                      <p className="text-slate-300 text-sm sm:text-base">{selectedMember.education}</p>
                    </div>

                    <div className="flex flex-wrap gap-3">
                      <a href={selectedMember.linkedin} className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 text-sm sm:text-base">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                        LinkedIn
                      </a>
                      <a href={`mailto:${selectedMember.email}`} className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-600 transition-colors duration-300 text-sm sm:text-base">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        Email
                      </a>
                    </div>
                  </div>
                </div>
                
                {/* Close Button */}
                <button
                  onClick={() => setSelectedMember(null)}
                  className="absolute top-2 right-2 sm:top-4 sm:right-4 w-8 h-8 sm:w-10 sm:h-10 bg-slate-800/80 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-slate-700/80 transition-colors duration-300"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-4 sm:p-6 md:p-8">
                <div className="mb-6 sm:mb-8">
                  <h4 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">About</h4>
                  <p className="text-slate-300 leading-relaxed text-sm sm:text-base">{selectedMember.bio}</p>
                </div>

                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Areas of Expertise</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                    {selectedMember.specialties.map((specialty, index) => (
                      <div key={index} className="flex items-center gap-3 bg-slate-800/20 rounded-lg p-2 sm:p-3">
                        <div className="w-2 h-2 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full flex-shrink-0" />
                        <span className="text-slate-300 text-sm sm:text-base">{specialty}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-30px) rotate(-5deg); }
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 10s ease-in-out infinite 2s;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
        .animate-fade-in-delayed {
          animation: fade-in 0.8s ease-out 0.6s both;
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out both;
        }
      `}</style>
    </section>
  );
};

export default Team;